import React from "react";
import AdvertisingModule from "@/components/admin/advertising/AdvertisingModule";

const AdvertisingManagement: React.FC = () => {
  return <AdvertisingModule />;
};

export default AdvertisingManagement;